/**
 * 价格指数列表页路径
 */
export const PRICE_INDEX_LIST_PATH = '/price-index/list'

/**
 * 价格指数创建页路径
 */
export const PRICE_INDEX_CREATE_PATH = '/price-index/create'

/**
 * 价格指数编辑页路径
 */
export const PRICE_INDEX_EDIT_PATH = '/price-index/edit'

/**
 * 价格指数类别管理页路径
 */
export const PRICE_INDEX_CATEGORY_PATH = '/price-index/category'
